<template>
  <v-file-input
    id="fileInput"
    dense
    label="File input"
    @change="$emit('change',$event)"
    :disabled="disabled"
    :multiple="multiple"
    :accept="conditionAccept"
  ></v-file-input>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "File input",
    },
    multiple: Boolean,
    disabled: Boolean,
    accept: {
      type: String,
      default: "all",
    },
  },
  methods: {
    clearFile() {},
  },
  computed: {
    conditionAccept() {
      switch (this.accept) {
        case "all":
          return "";
        case "image":
          return "image/*";
        case "excel":
          return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";
      }
    },
  },
};
</script>